import { FC } from 'react'
import type { Project } from '@/types'
import { ProjectGridCell } from '@/components/projectCell/ProjectGridCell'
import type { AllProjectCountersWithOverdue } from '@/queries/projectCounters'

interface IProps {
  projects: Project[]
  counts?: AllProjectCountersWithOverdue
}

export const GridMode: FC<IProps> = ({ projects, counts }) => {
  const cells = projects.map((p, i) => <ProjectGridCell key={i} project={p!} counts={counts?.[p.get('idd')]} />)
  return (
    <div className="mb-2 flex flex-row flex-wrap items-center justify-evenly md:mx-2 md:justify-start">{cells}</div>
  )
}
